module.exports = __webpack_public_path__ + "img/hermelin_logo.b79446fc.svg";